const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "BOOOMJAM 游戏创作挑战，保时捷特别回合，今日启程"
const desc = "24 年最大一次的 jam 活动来了！参与游戏还将出展北京核聚变"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
    links: {
      qa: "https://m7ayg0zzno.feishu.cn/docx/EFxNddJpiolWpHxMArlcyr8dnve",
      submit: "https://www.gcores.com/dev_community/manage",
      submitGuide:
        "https://m7ayg0zzno.feishu.cn/docx/PcHHd2rcsonjEDxooefct7WNnsK",
      enroll:
        "https://m7ayg0zzno.feishu.cn/share/base/form/shrcnTEKB1tLFJj7AHOWqSGgSDe",
      teamMember:
        "https://m7ayg0zzno.feishu.cn/docx/EFxNddJpiolWpHxMArlcyr8dnve?from=from_copylink",
    },
  },
}
